import {SerializeClass} from "models/SerializeClass";
import {OperationalUser} from "models/global/OperationalUser";

export class Hotel extends SerializeClass {

	private _city: string = "";
	private _class: string = "";
	private _id: number = -1;
	private _name: string = "";
	private _currency: string = "";
	private _hasReportData: boolean = false;
	private _operationalUsers: OperationalUser[] = [];


	get city(): string {
		return this._city;
	}

	set city(value: string) {
		this._city = value;
	}

	get class(): string {
		return this._class;
	}

	set class(value: string) {
		this._class = value;
	}

	get id(): number {
		return this._id;
	}

	set id(value: number) {
		this._id = value;
	}

	get name(): string {
		return this._name;
	}

	set name(value: string) {
		this._name = value;
	}

	get currency(): string {
		return this._currency;
	}

	set currency(value: string) {
		this._currency = value;
	}

	get hasReportData(): boolean {
		return this._hasReportData;
	}

	set hasReportData(value: boolean) {
		this._hasReportData = value;
	}

	get operationalUsers(): any {
		return this._operationalUsers;
	}

	set operationalUsers(value: any) {
		this._operationalUsers = value;
	}
}